import { useEffect } from "react";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import WhatIDo from "@/components/landing/WhatIDo";
import WhatWeBring from "@/components/landing/WhatWeBring";
import FinanceOS from "@/components/landing/FinanceOS";
import About from "@/components/landing/About";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  useEffect(() => {
    document.title = "RCS Labs — Fractional CFO, Venture Incubation, Investor Readiness and Angel Capital";
  }, []);

  return (
    <div className="grain min-h-screen bg-cream text-ink antialiased">
      <Navigation />
      <main>
        <Hero />
        <Marquee />
        <WhatIDo />
        <WhatWeBring />
        <FinanceOS />
        <About />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
